import * as actionTypes from '../../../../models/actionTypes';
import { RequestFeedbackSchema, SurveyCheckBoxCategories } from '../../models/feedbackModels';
import { FreelanceRequest } from '../../models/requestModels';

export const submitFeedback = (
  requestData: FreelanceRequest,
  ratingText: string,
  requestId: string,
  checkBoxes: SurveyCheckBoxCategories
) => {
  return {
    type: actionTypes.SUBMIT_FEEDBACK,
    requestData,
    ratingText,
    requestId,
    checkBoxes,
  };
};

export const submitFeedbackSuccess = (requestId: string) => {
  return {
    type: actionTypes.SUBMIT_FEEDBACK_SUCCESS,
    requestId,
  };
};

export const submitFeedbackError = (requestId: string) => {
  return {
    type: actionTypes.SUBMIT_FEEDBACK_ERROR,
    requestId,
  };
};

export const updateFeedback = (requestFeedbackSchema: RequestFeedbackSchema) => {
  return {
    type: actionTypes.UPDATE_FEEDBACK,
    requestFeedbackSchema,
  };
};

export const resetFeedback = (requestId: string) => {
  return {
    type: actionTypes.RESET_FEEDBACK,
    requestId,
  };
};
